<!--
 * @Description: 
 * @Date: 2020-11-10 16:47:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:36:42
-->
<template>
  <div class="audit">
    <svg
      class="audit-svg"
      width="200"
      height="200"
      viewport="0 0 200 200"
      :d="d"
    >
      <defs>
        <filter id="f1" x="0" y="0" width="200%" height="200%">
          <feOffset result="offOut" in="SourceGraphic" dx="10" dy="10" />
          <feColorMatrix
            result="matrixOut"
            in="offOut"
            type="matrix"
            values="0 0 0 0 0.76953125 0 0 0 0 0.76953125 0 0 0 0 0.76953125 0 0 0 1 0"
          />
          <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="5" />
          <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
        </filter>
      </defs>
      <path :d="d[1]" fill="#FFF2CB" class="path-1" filter="url(#f1)" />
      <path :d="d[3]" fill="#C2C1FF" class="path-2" filter="url(#f1)" />
      <path :d="d[0]" fill="#FFC81D" />
      <path :d="d[2]" fill="#2722FF" />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getPathD(deg1, deg2) {
      const d90 = Math.abs(deg2 - deg1) >= 180;
      const dis = 20;
      const r1 = 75;
      const r2 = 55;
      const degForSin = Math.sin((Math.PI * deg1) / 180);
      const degForCos = Math.cos((Math.PI * deg1) / 180);
      const point1 = [r1 - r1 * degForCos + dis, r1 - r1 * degForSin + dis];
      const point2 = [r1 - r2 * degForCos + dis, r1 - r2 * degForSin + dis];

      const degForSinEnd = Math.sin((Math.PI * deg2) / 180);
      const degForCosEnd = Math.cos((Math.PI * deg2) / 180);
      const point1End = [
        r1 - r1 * degForCosEnd + dis,
        r1 - r1 * degForSinEnd + dis
      ];
      const point2End = [
        r1 - r2 * degForCosEnd + dis,
        r1 - r2 * degForSinEnd + dis
      ];
      return `M${point1[0]} ${point1[1]} A${r1} ${r1} 0 ${d90 ? 1 : 0} 1 ${
        point1End[0]
      } ${point1End[1]} L${point2End[0]} ${point2End[1]} A${r2} ${r2} 0 ${
        d90 ? 1 : 0
      } 0 ${point2[0]} ${point2[1]} z`;
    }
  },
  computed: {
    d() {
      const total = this.total;
      const value = this.value;
      const deg = Math.min((270 * value) / total, 270);
      return [
        this.getPathD(0, Math.max(deg - 3, 0)),
        this.getPathD(0, Math.max(deg - 3, 0)),
        this.getPathD(Math.min(deg + 3, 270), 270),
        this.getPathD(Math.min(deg + 3, 270), 270)
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.audit-svg {
  transform: rotate(25deg);
  path {
    transition: all 0.3s;
  }
  .path-1 {
    transform: translate(4px, 2px);
  }
  .path-2 {
    transform: translate(0px, 5px);
  }
}
</style>
